import { createContext, useMemo } from 'react';

import type { Configuration } from '../../types';

interface ConfigContextValue {
  config: Configuration;
}

const ConfigContext = createContext<ConfigContextValue | null>(null);

export interface ConfigProviderProps {
  config: Configuration;
  children: React.ReactNode;
}

function ConfigProvider(props: Readonly<ConfigProviderProps>) {
  const { config, children } = props;

  const contextValue = useMemo(
    () => ({
      config,
    }),
    [config],
  );

  return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
}

export { ConfigContext, ConfigProvider };
